import React, { Component } from 'react'
import './SeparatorBar.css'

class SeparatorBar extends Component {
  render() {
    const { type } = this.props
    const isHorizontal = type === 'horizontal'
    const className = isHorizontal ? 'SeparatorBar SeparatorBar--horizontal' : 'SeparatorBar'
    const topClassName = isHorizontal ? 'SeparatorBar-top SeparatorBar-top--horizontal' : 'SeparatorBar-top'
    const bottomClassName = isHorizontal ? 'SeparatorBar-bottom SeparatorBar-bottom--horizontal' : 'SeparatorBar-bottom'
    return (
      <div className={className + ' ' + this.props.className}>
        <div className={topClassName}></div>
        <div className={bottomClassName}></div>
      </div>
    )
  }
}

export default SeparatorBar


// WEBPACK FOOTER //
// ./src/components/SeparatorBar/index.js